<template>
     <!-- 全屏容器 -->
     <div class="main">

      <dv-full-screen-container id="index-box">

        <div class="top-header">
          <dv-decoration-8 style="width:25%;height:60px;" />
          <dv-decoration-5 style="width:40%;height:60px;margin-top:40px" />
          <dv-decoration-8 :reverse="true" style="width:25%;height:60px;" />
          <div class="center-title">AEO大数据</div>
        </div>
        <div class="topBtn">
          <div class="search">
            <span class="active">2023</span>
            <span>2022</span>
            <span>2021</span>
          </div>

          <div class="full-screen" @click="toFullOrExit">
            <img :src="fullImg" alt="">
          </div>
        </div>
            <div class="index">
              <div class="left">
                <div style="width:50%">
                   <Four></Four>
                   <Nine></Nine>
                    <Ten></Ten>
                </div>
                <div style="width:50%">
                   <Two ></Two>
                   <Six></Six>
                   <Five></Five>
                </div>
              </div>
              <div class="center">
                  <div class="total">
                      <div class="totalItem">
                        <div class="icon">
                          <img src="https://www.axureux.com/demo/Templates022/images/tem001/u669.svg" alt="" />
                        </div>
                        <div class="numberBox">
                          <div class="numberText">进口贸易额</div>
                          <div class="number">{{importTotal}}</div>
                        </div>
                      </div>
                      <div class="totalItem">
                        <div class="icon">
                          <img src="https://www.axureux.com/demo/Templates022/images/tem001/u672.svg" alt="" />
                        </div>
                        <div class="numberBox">
                          <div class="numberText">出口贸易额</div>
                          <div class="number">{{exitTotal}}</div>
                        </div>
                      </div>
                    </div>
                  <div class="map" style="padding:0 20px">

                   <div class="returnBox" v-show="isreturn">
                     <div class="return" @click="rebackMap" >返回</div>
                     <span class="mapName">{{mapName}}省地图</span>
                     <span></span>
                   </div>
                    <div id="map" style="height:100%;"></div>
                  </div>
              </div>
              <div class="right">
                <Three></Three>

               <Eight></Eight>
                <One></One>



              </div>

            </div>
         <!-- </dv-border-box-11> -->
      </dv-full-screen-container>
    </div>
</template>

<script>
  import cityExport from '../components/cityExport.js';
  import statusCity from '../components/annotatedCity.js';
  import * as echarts from 'echarts';
  import imgTest from "../../static/haiguan.png";

  import One from '../components/left/one.vue';
  import Two from '../components/left/two.vue';
  import Three from '../components/left/three.vue';
  import Four from '../components/right/four.vue';
  import Five from '../components/right/five.vue'

  import Six from '../components/right/six.vue'
  import Seven from '../components/right/seven.vue'
  import Eight from '../components/right/eight.vue'

  import Nine from '../components/left/nine.vue'
  import Ten from '../components/left/ten.vue'

export default {
  name: 'index',
  components: {
      One,
      Two,
      Three,

      Four,
      Five,
      Six,
      Seven,
      Eight,
      Nine,
      Ten
  },
  data () {
    return {
      fullImg:"../../static/quanping_o.png",
      isFull:false,
      isreturn: false, // 是否显示返回全国地图按钮
      mapChart: null, //地图对象
      mapOption: null,//地图属性
      mapName:"",
      dataList: [ //地图标记经纬度坐标和code码,可只要经纬度
        { name: "黄埔海关", value: [	113.709693, 23.163951]},
        { name: "江门海关", value: [113.081415, 22.579089]},
      ],
      AEOTotal:'219,654.76',//AEO认证企业总数
      importTotal:'279,024.06',//进口贸易额
      exitTotal:'225,034.02',//出口贸易额
      seriesData:{},
      regions:{},


    }
  },
   mounted() {
     console.log(cityExport)
      setTimeout(()=>{
       this.getMap();
     },1000)
     this.$axios.post('user/login.do', {
         name:'1'
     }, response => {

     });
    },
    methods: {
        getMap() {
          if (!this.mapChart) {
            this.mapChart = this.$echarts.init(document.getElementById('map'));
          }
          let symbolImg = 'image://'+ imgTest
          this.mapOption = {
            tooltip: {// 提示浮窗样式
              show: true,
              trigger: "item",
              alwaysShowContent: false,
              backgroundColor: "#121837",
              borderColor: "#7881B3",
              hideDelay: 100,
              triggerOn: "mousemove",
              enterable: true,
              textStyle: {
                color: "#DADADA",
                fontSize: "12",
                width: 20,
                height: 30,
                overflow: "break",
              },
              showDelay: 100
            },
            map: 'china',
            roam: true,//是否启缩放和平移
            scaleLimit: {
              min: 1,
              max: 5
            },
            label: {
              normal: {
                show: true,
                fontSize: '10',
                color: '#fff'
              }
            },
            geo: {// 地图配置
              map: "china",
              //roam: true,// 可以通过鼠标滚轮放大缩小地图
              zoom:'1.2',
              show: true,
              label: {
                normal: {
                  show: false,//是否显示地图省份名字
                  textStyle: {
                    color: "#fff",//地图名字颜色
                  },
                },
                emphasis: { // 鼠标放上去地图文字的样式
                  textStyle: {
                    color: "#eee",
                  },
                },
              },
              itemStyle: { // 地图区域的样式设置
                normal: {
                  areaColor: 'rgba(49, 167, 225, .2)', //rgba设置透明度0
                  borderColor: "#39A1FB",
                  borderWidth: 1,
                },
                emphasis: {  // 鼠标放上去地图高亮的样式
                  areaColor: "rgba(49, 167, 225, .7)",
                  borderWidth: 0,
                },
              },
            },
            series: [
              {
                type: "map",
                map: "china",
                name: '港口信息',
                coordinateSystem: 'geo',
                type: 'scatter',
                symbol: symbolImg, //自定义的展示图标
                symbolSize:20,
                roam: false,
                  label: {
                      formatter: (params) => {
                        return params.data.name;
                      },
                      color: '#fff',
                      backgroundColor: '#EE1D23',
                      lineHeight: 16,
                      padding: 3,
                      show: true,
                      position: 'left',
                      rich: {
                      }
                  },
                data: []
              }

            ],
          };
          //将中国地图 分为市为单位
          let chinaData = {
            type:"FeatureCollection",
            features:[]
          }
          let newData  = cityExport.china.features.filter(function(item) {
            return (item.properties.name != "广东") && (item.properties.name != "内蒙古") && (item.properties.name != "山东") && (item.properties.name != "浙江") && (item.properties.name != "福建") && (item.properties.name != "辽宁")
          });
          for(let i =0;i<cityExport.cityList.length;i++){
            if(cityExport.cityList[i].name.indexOf('广东')!='-1' || cityExport.cityList[i].name.indexOf('内蒙古')!='-1' || cityExport.cityList[i].name.indexOf('山东')!='-1' || cityExport.cityList[i].name.indexOf('浙江')!='-1'|| cityExport.cityList[i].name.indexOf('福建')!='-1'|| cityExport.cityList[i].name.indexOf('辽宁')!='-1'){

              if(cityExport.cityList[i].name.indexOf('广东')!='-1'){
                console.log(cityExport.cityList[i].data.features,'888');
                let arr  = cityExport.cityList[i].data.features.filter(function(item) {//把广州市删除替换成区的方式显示
                     return item.properties.name != "广州市"
                 });
                 let arr1 = arr.concat(cityExport.guangzhou.features)
                 newData = newData.concat(arr1);
              }else{
                 newData = newData.concat(cityExport.cityList[i].data.features);
              }
            }
          }
          chinaData.features = newData;
          //将中国地图 分为市为单位

          // 地图注册，第一个参数的名字必须和option.geo.map一致
          this.$echarts.registerMap('china', chinaData);
          console.log(statusCity.statusCity,'活跃的城市');
          console.log(cityExport.cityList,'市');
          console.log(cityExport.china,'中国');
          let seriesData = [];
          let regions = [];
          for(let key in statusCity.statusCity){
            seriesData = seriesData.concat(statusCity.statusCity[key].seriesData);
            for(let i=0;i<statusCity.statusCity[key].regions.length;i++){
              regions.push({
                name: statusCity.statusCity[key].regions[i].name,
                label: { color: statusCity.statusCity[key].regions[i].fontColor },
                itemStyle: { areaColor: statusCity.statusCity[key].regions[i].BgColor },
                parentName:key
              })
            }
          }
          console.log(seriesData,'seriesData')
          console.log(regions,'regions')

          this.mapOption.geo.regions = regions;//设置显示的海关
          this.regions = regions;
          this.mapOption.series[0].data = seriesData;//中国设置市级单位显示
          this.seriesData = seriesData;
          this.mapChart.setOption(this.mapOption);


          //地图点位点击事件
          this.mapChart.on('click', params => {
            let provinceName = params.region.parentName?params.region.parentName:params.name;
            this.mapName = provinceName;
            console.log(params);
            console.log(provinceName)
            // 判断点击的省份是否有标记点 有则只显示该省的标记 否则会将其他省份的坐标点一起显示
            cityExport.cityList.map((value,index) => {
              if (value.name.indexOf(provinceName) !== -1) {
                this.mapChart.clear();
                let data = {};
                if(provinceName=='广东'){
                  data = {
                    features:[],
                    type: "FeatureCollection"
                  };
                  let newData  = value.data.features.filter(function(item) {//把广州市删除替换成区的方式显示
                       return item.properties.name != "广州市"
                   });
                  data.features = newData.concat(cityExport.guangzhou.features);
                  this.mapOption.series[0].data = [
                    { name: "黄埔海关", value: [	113.709693, 23.163951]},
                    { name: "江门海关", value: [113.081415, 22.579089]},
                    { name: "汕头海关", value: [116.747794,23.383024]},
                    { name: "湛江海关", value: [110.357229,21.206645]},
                    { name: "深圳海关", value: [114.072841,22.546755]},
                    { name: "拱北海关", value: [113.563842,22.223781]},
                    { name: "广州海关", value: [113.326979,23.126103]},
                  ];
                  this.mapOption.geo.regions = [{
                    name: '黄埔区',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '增城区',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '东莞市',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '江门市',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#63AEEB' }
                  },{
                    name: '阳江市',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#63AEEB' }
                  },{
                    name: '汕头市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '潮州市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '普宁市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '揭阳市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '汕尾市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '梅州市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '湛江市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0290A9' }
                  },{
                    name: '茂名市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0290A9' }
                  },
                  {
                    name: '深圳市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#38B03F' }
                  },
                  {
                    name: '惠州市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#38B03F' }
                  },

                  {
                    name: '珠海市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#B4A2FF' }
                  },
                  {
                    name: '中山市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#B4A2FF' }
                  },

                  {
                    name: '佛山市',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '肇庆市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '韶关市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '河源市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '清远市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '云浮市',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '荔湾区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '越秀区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '海珠区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '天河区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '白云区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '番禺区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '花都区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '南沙区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '从化区',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  ]
                }else{
                  data = value.data;
                  let obj = {
                    '内蒙古':{
                      seriesData:[
                        { name: "满洲里海关", value: [117.508763,49.589511]},
                        { name: "呼和浩特海关", value: [	111.779042,40.839318]},
                      ],
                      regions:[
                        {name:'呼伦贝尔市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'赤峰市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'通辽市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'兴安盟',fontColor:'#000',BgColor:'#63AEEB'},

                        {name:'锡林郭勒盟',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'呼和浩特市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'包头市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'鄂尔多斯市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'乌海市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'巴彦淖尔市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'乌兰察布市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'阿拉善盟',fontColor:'#000',BgColor:'#A2D6F5'},
                      ],
                    },
                    '辽宁':{
                      seriesData:[
                        { name: "大连海关", value: [123.310344,39.868812]},
                        { name: "沈阳海关", value: [123.468733,41.751897]}
                      ],
                      regions:[
                        {name:'大连市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'鞍山市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'本溪市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'丹东市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'营口市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'盘锦市',fontColor:'#000',BgColor:'#63AEEB'},

                        {name:'沈阳市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'抚顺市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'辽阳市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'锦州市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'阜新市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'葫芦岛市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'铁岭市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'朝阳市',fontColor:'#000',BgColor:'#A2D6F5'},
                      ],
                    },
                    '福建':{
                      seriesData:[
                        { name: "厦门海关", value: [117.673854,25.263332]},
                        { name: "福州海关", value: [119.420199,26.021305]}
                      ],
                      regions:[
                        {name:'厦门市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'泉州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'漳州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'龙岩市',fontColor:'#000',BgColor:'#63AEEB'},

                        {name:'福州市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'莆田市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'三明市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'南平市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'宁德市',fontColor:'#000',BgColor:'#A2D6F5'},
                      ],
                    },
                    '山东':{
                      seriesData:[
                        { name: "济南海关", value: [116.966009,36.890723]},
                        { name: "青岛海关", value: [120.318301,36.063604]}
                      ],
                      regions:[
                        {name:'济南市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'淄博市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'潍坊市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'泰安市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'东营市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'德州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'滨州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'聊城市',fontColor:'#000',BgColor:'#63AEEB'},

                        {name:'青岛市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'枣庄市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'烟台市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'济宁市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'威海市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'日照市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'临沂市',fontColor:'#000',BgColor:'#A2D6F5'},
                        {name:'菏泽市',fontColor:'#000',BgColor:'#A2D6F5'},
                      ],
                    },
                    '浙江':{
                      seriesData:[
                        { name: "杭州海关", value: [120.142681,30.276457]},
                        { name: "宁波海关", value: [121.543503,29.877679]}
                      ],
                      regions:[
                        {name:'杭州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'温州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'嘉兴市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'湖州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'绍兴市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'金华市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'衢州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'舟山市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'台州市',fontColor:'#000',BgColor:'#63AEEB'},
                        {name:'丽水市',fontColor:'#000',BgColor:'#63AEEB'},

                        {name:'宁波市',fontColor:'#000',BgColor:'#A2D6F5'}
                      ],
                    },

                  }
                  if(obj[`${provinceName}`]){
                    console.log(777)
                    this.mapOption.series[0].data = obj[`${provinceName}`].seriesData;
                   let regions = [];
                   for(let i=0;i<obj[`${provinceName}`].regions.length;i++){
                    regions.push({
                      name: obj[`${provinceName}`].regions[i].name,
                      label: { color: obj[`${provinceName}`].regions[i].fontColor },
                      itemStyle: { areaColor: obj[`${provinceName}`].regions[i].BgColor }
                    })
                   }
                   this.mapOption.geo.regions = regions;
                  }else{
                    console.log(888);
                    this.mapOption.series[0].data = [];
                    this.mapOption.geo.regions = [];
                  }
                }

                this.mapOption.geo.map = 'Pmap';
                this.$echarts.registerMap('Pmap', data);
                this.mapChart.setOption(this.mapOption);
                this.isreturn = true;
              }
            });

          })
          this.mapChart.on('georoam', params => {
             //posHandler.reset();
             this.mapChart.resize();
          })
        },
        rebackMap() { //返回全国地图
          this.mapChart.clear();
          this.mapOption.geo.regions = this.regions;//设置显示的海关
          this.mapOption.series[0].data = this.seriesData;
          this.mapOption.geo.map = 'china';
          this.mapChart.setOption(this.mapOption);
          this.isreturn = false;
        },
        requestFullScreen () {
          let de = document.documentElement
          if (de.requestFullscreen) {
            de.requestFullscreen()
          } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen()
          } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen()
          }
        },
        exitFullscreen () {
          let de = document
          if (de.exitFullscreen) {
            de.exitFullscreen()
          } else if (de.mozCancelFullScreen) {
            de.mozCancelFullScreen()
          } else if (de.webkitCancelFullScreen) {
            de.webkitCancelFullScreen()
          }
        },
        toFullOrExit () {
          this.isFull = !this.isFull
          if (this.isFull) {
            this.fullImg = require('../../static/quxiaoquanping_o.png')
            this.requestFullScreen()
          } else {
            this.fullImg = require('../../static/quanping_o.png')
            this.exitFullscreen()
          }
        }


      }
}

</script>

<style>
  @font-face {
      font-family: "DIN_Condensed_Bold";
      src: url("../../static/DIN_Condensed_Bold.ttf");
  }
  .main{
    position: relative;
  }
  .topBtn{
    position: absolute;
    top:10px;
    width: 100%;
    padding:0 15px;
    display: flex;
    justify-content: space-between;
  }
  .full-screen img{
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
  #index-box{
    background: url(../../static/bg3.jpg);
    background-size: cover!important;
  }
  .totalItem{
    width: 250px;
    height: 100px;
    background: inherit;
    background-color: rgba(49, 167, 255, 0.298039215686275);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .totalItem .icon{
    margin-right:15px;
  }
  .totalItem .numberText{
    font-size: 16px;
    font-family: '微软雅黑';
    font-weight: 400;
  }
  .totalItem .number{
    font-size: 36px;
    font-family: 'DIN_Condensed_Bold';
    font-weight: 700;
    padding-top:6px;
  }
  .height33{
    height: 30%;
  }
  .top-header{
        position: relative;
        width: 100%;
        height: 100px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-negative: 0;
        flex-shrink: 0;

  }
  .top-header .center-title {
      position: absolute;
      font-size: 30px;
      font-weight: 700;
      left: 50%;
      top: 15px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      color:#fff;
  }
  .map{
    height: calc(100vh - 70px);
  }
  .mapName{
    color:#fff;
    font-size:18px;
    font-weight:bold;
  }
  .tips{
    position:absolute;
    bottom:30px;
    left:30px;
    color:red;
  }
   .tips span{
     border:1px solid red;
     padding:10px 15px;
     margin-right:10px;
   }
  .search{
    display:flex;
    align-items: left;

    margin-top:20px;
    margin-bottom:20px;
  }
  .search span{
    background-color: rgba(49, 167, 255, 0.298039215686275);
    color:#fff;
    padding:10px 20px;
    border-radius:5px;
    margin-right:8px;
    cursor:pointer;

  }
  .search span.active{
    background-color: rgba(49, 167, 255, .8);
    color:#fff;
  }
  .tableBox{
    display:flex;
    padding:10px 30px;
  }
  .leftTable,.rightTable{
    flex:1
  }
  .box1 {
      width: 610px;
      height: 310px;
  }
  .box{
 /* background-color: rgba(49, 167, 255, 0.2); */
   background-color: rgba(57, 161, 251, 0.1);
    /* border-top: 2px solid rgba(1,153,209,.5); */
    color:#fff;
    text-align: left;
    padding:10px 15px 0 15px;
    margin-bottom: 25px;
  }
  .boxTitle{
    border-left:6px solid #00ADEF;
    font-size: 24px;
    font-weight: bold;
    display: inline-block;
    padding:2px 15px;
  }
  .boxTitleTips{
    font-size: 22px;
    padding:30px 0;
    text-align: center;
  }
.index{
  display:flex;
  padding:30px 30px;
  width:100%;
  box-sizing: border-box;
  height: calc(100vh - 70px);
}
.left{
  width:25%;
  display: flex;
}
.center{
  width:50%;
  position:relative;
 /* overflow: hidden; */
/*  min-width: 1000px; */
}
.right{
  width:25%;
  color:#fff;
}
.returnBox{
  display: flex;
  justify-content: space-between;
}
.return{

  z-index:99999999;
  color:#fff;
  cursor:pointer;
}
.total{
  display:flex;
  justify-content:space-between;
  position: absolute;
  top:60px;
  padding: 0 20px;
  z-index: 99999999;
  width:900px;
  left:50%;
  margin-left: -500px;
}
.number{
  display:flex;
  align-items:center;
  font-size:26px;
  color:#fff;
}
.number span{
  font-size:28px;
  font-weight:bold;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue